import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/horarios/groups";
import groups from "../../models/horarios/groups";
import moment from "moment";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    groups: [],
    new: [],
    edit: [],
    deleteItem: [],
    showAdd: false,
    scheduleId: null,
    openGroup: false,
    mode: "",
    openDelete: false,
  },

  mutations: {
    setGroups(state, data) {
      state.groups = data;
    },

    setEdit(state, data) {
      state.edit = data;
    },

    setDeleteItem(state, data) {
      state.deleteItem = data;
    },
    setShowAdd(state, data) {
      state.showAdd = data;
    },

    setNew(state, data) {
      state.new = data;
    },
    setOpenGroup(state, data) {
      state.openGroup = data;
    },
    setMode(state, data) {
      state.mode = data;
    },
    setScheduleId(state, data) {
      state.scheduleId = data;
    },
    setOpenDelete(state, data) {
      state.openDelete = data;
    },
  },
  actions: {
    async getGroups(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let items = await state.state.service.getGroups(
            state.state.scheduleId
          );

          items = items.map((item) => {
            if (item.instans && item.instans.length > 0) {
              item.instans.sort((a, b) => {
                let dateA = new Date(a.fecDesde);
                let dateB = new Date(b.fecDesde);
                return dateB - dateA;
              });
            }
            return item;
          });

          state.commit("setGroups", items);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async edit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.edit(state.state.edit).then(async () => {
            let data = {
              schedule: state.state.edit.schedule,
              grpId: state.state.edit.id,
            };

            const group = await state.state.service.getGroupById(data);
            let options = state.state.groups;
            options = options.map((option) => {
              if (option.id === data.grpId) {
                option.instans = group.data;
                return option;
              }
              return option;
            });

            state.commit("setGroups", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    async new(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.new(state.state.new).then(({ data }) => {
            let item = state.state.new;
            let options = state.state.groups;
            let newItems = [];
            item.groups.forEach((id, index) => {
              if (data[index].CodError !== 1) {
                newItems.push(
                  groups.fromJson({
                    grpId: id,
                    grpNombre: item.names[0],
                    instancias: [
                      {
                        fecDesde: item.from,
                        fecHasta: moment
                          .utc(item.to)
                          .add(1, "days")
                          .format("YYYY-MM-DD"),
                        numSecuencia: item.sequenceNumber,
                        segmDespl: item.initialDay,
                        segmId: item.segment,
                      },
                    ],
                  })
                );
              }
            });
            options.push(...newItems);
            state.commit("setGroups", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.delete(state.state.deleteItem).then(() => {
            let options = state.state.groups;
            options = options.filter((option) => {
              return option.id != state.state.deleteItem.id;
            });
            state.commit("setGroups", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
